/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据projectId获取场次信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetShowInfosByProjectIdParams {
  constructor(
    public distributionChannelId?: string,
    public distributionSeriesId?: string
  ) {}
}

export default async function (
  projectId: string,

  params: GetShowInfosByProjectIdParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.ProjectShowsDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shows/old/${projectId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
